import { ChangeEventsPipelineManager } from "@hds/entity-lib";
import { DeltaServerChangeEventsReadableStream } from "./DeltaServer.change-events-readable-stream.mjs";

class DeltaServerChangeEventsPipelineManager extends ChangeEventsPipelineManager {
    #_deltaServerClient;//direct access to the DeltaServer DB
    #_topic;
    constructor(deltaServerClient, topic, projection = undefined) {
        super(projection);
        this.#_deltaServerClient = deltaServerClient;
        this.#_topic = topic;
    }
    /*****************************************************/
    /* START ABSTRACT METHODS */
    /*****************************************************/
    async _createChangeEventsReadableStream() {
        const changeEventsReadableStream = new DeltaServerChangeEventsReadableStream(this.#_deltaServerClient, this.#_topic, this._projection);
        await changeEventsReadableStream.whenInitialized();
        return changeEventsReadableStream;
    }
    /*****************************************************/
    /* END ABSTRACT METHODS */
    /*****************************************************/
    get deltaServerClient() {
        return this.#_deltaServerClient;
    }
    get topic() {
        return this.#_topic;
    }
}
export { DeltaServerChangeEventsPipelineManager };
export default { DeltaServerChangeEventsPipelineManager };